<div class="container-fluid ml-n2" :class="{ 'limited-height-mode': limitedHeightMode }">
  <div>
    <div v-if="limitedHeightMode" class="ml-2 mt-2">{{ $t('individual.individual_diagnosis_function_vehicle_control_history') }}</div>
    <div class="list-detail-top mt-2">
      <div>
        <b-button class="ml-2 mt-2" :disabled="isDisabledBtn" variant="primary" size="sm" v-on:click="openNoteModal()">
          {{ $t('message.button_vehicle_dtc_note_modal') }}
        </b-button>
        <b-button v-if="testModeVisible" class="ml-2 mt-2" variant="primary" size="sm" v-on:click="bmcTestDataExport">
          Export BMC Data
        </b-button>
        <b-button class="ml-2 mt-2" variant="primary" size="sm" :disabled="isDisabledBtn" @click="csvExport">
          {{ $t('message.file_export') }}
        </b-button>
      </div>
      <div>
        <b-button class="ml-2 mt-2" :disabled="isDisabledBtn" variant="primary" size="sm" v-on:click="regetBmc()">
          {{ $t('message.button_vehicle_dtc_gain_again') }}
        </b-button>
        <b-button class="ml-2 mt-2" :disabled="isDisabledBtn" variant="primary" size="sm" v-on:click="deleteBmc()">
          {{ $t('individual.button_vehicle_bmc_remove') }}
        </b-button>
      </div>
    </div>
  </div>

  <cstm-table useSort hasTabs rowSelect initSortDir="asc" :items="bmcListItems" :columns="bmcSystemTableColumns"
    class="mt-2 ml-2 vch-cstm-table" type="simple" useStripeStyle @rowButtonClicked="clickBMD" currentSortkey="status">
    <template v-slot:rowButton="{ row }">
      <img v-if="row.isMultiFFD" class="ffd_icon_style" src="@/assets/img/bmd/bmd_multi.png" draggable="false" />
      <img v-else class="ffd_icon_style" src="@/assets/img/ffd/ffd_single.png" draggable="false" />
    </template>
  </cstm-table>

  <!-- BMD詳細画面 -->
  <b-modal v-model="modalBmd" size="huge" header-bg-variant="secondary" header-text-variant="light" no-stacking
    no-close-on-backdrop no-close-on-esc centered scrollable>
    <!-- BMDタイトルの設定 -->
    <template v-slot:header>
      <div class="text-center w-100">
        {{ bmdTitle }}
      </div>
    </template>

    <bmd-modal v-if="modalBmd" :bmdTableProp="bmdSystemTable" :systemProp="selectedSystem" :bmdSystem="bmdSystem"
      :bmdDescription="bmdDescription" destinationAPI="vch" :projectId="vehicleInfo.vehicle.project.id"
      :measureId="measuredId" @updateLoading="processing = $event" ref="bmd_modal">
      <template v-slot:didTestBtn>
        <b-button v-if="testModeVisible" class="clear-button" variant="primary" size="sm" @click="didTestDataExport()">
          Export DID Data
        </b-button> 
      </template>
    </bmd-modal>

    <template v-slot:footer>
      <div class="text-center w-100">
        <b-button size="sm" variant="primary" @click="modalBmd=false" class="ml-2 mr-2">
          {{ $t("message.common_button_ok") }}
        </b-button>
      </div>
    </template>
  </b-modal>

  <!-- メモ画面 -->
  <b-modal v-model="modalMemo" size="lg" header-bg-variant="secondary" header-text-variant="light" no-stacking
    no-close-on-backdrop no-close-on-esc centered scrollable>
    <template v-slot:header>
      <div class="text-center w-100">
        {{ $t('message.header_vehicle_dtc_note_modal') }}
      </div>
    </template>

    <memo-Page v-if="modalMemo" ref="memo"
      :projectId="vehicleInfo.vehicle.project.id"
      :measureId="measuredId"
      destinationAPI="vch"
      functionNameKey="individual.individual_diagnosis_function_vehicle_control_history"
      @closeNoteModal="closeNoteModal"
      :modalLoading="isMemoDialogLoading" @update-loading="isMemoDialogLoading = $event"
    />

    <template v-slot:footer>
      <button type="button" :disabled="isMemoDialogLoading" v-on:click="memoClear()"
        class="btn clear-button ml-3 btn-outline-primary btn-sm rounded-pill">{{ $t("message.common_button_clear") }}
      </button>
      <div class="text-center w-100">
        <b-button size="sm" :disabled="isMemoDialogLoading" variant="outline-primary" @click="modalMemo=false" class="ml-2 mr-2">
          {{ $t("message.common_button_cancel") }}
        </b-button>
        <b-button size="sm" :disabled="isMemoDialogLoading" variant="primary" @click="memoSave()" class="ml-2 mr-2">
          {{ $t('message.common_button_save') }}
        </b-button>
      </div>
    </template>
  </b-modal>

  <processing-view :processing="processing"></processing-view>
</div>